import React, { Component } from 'react';
import ReactDOM from 'react-dom';

/**
 * Accent Cirlces
 * @param null
 */
export class AccentCircles extends Component {
    
    constructor() {
        super();
        this.sizes = this.yayNay([650, 100], [450, 90]); /** [diameter, stroke-width] */
        this.stroke = this.yayNay('#E7EAF3', '#0005BC');
        this.top = this.yayNay(`-${this.sizes[0]/2}px`, `calc(100% - ${this.sizes[0]/2}px)`);
        this.left = this.yayNay(`-${this.sizes[0]/2}px`, `calc(100% - ${this.sizes[0]/2}px)`);
    }

    yayNay(a, b) {
        return  Math.round(Math.random()) ? a : b;
    }

    circle() {
        const svgStyle = {
            top: this.top,
            left: this.left
        };
        return (
            <svg 
                style={svgStyle}
                className={`accent-circle`}
                width={this.left === `-${this.sizes[0]/2}px` ? this.sizes[0] : (this.sizes[0] / 2)} 
                height={this.sizes[0]}>
                <circle 
                    preserveAspectRatio="xMinYMid slice"
                    cx={this.sizes[0]/2} 
                    cy={this.sizes[0]/2} 
                    r={(this.sizes[0] / 2) - (this.sizes[1] / 2)} 
                    fill="transparent"
                    stroke={this.stroke}
                    strokeWidth={this.sizes[1]}
                    opacity={this.stroke = '#0005BC' ? '.9' : '.6'}
                ></circle>
            </svg>
        );
    }

    render() {
        return this.circle();
    }
}

const accentCircleElements = document.querySelectorAll('[data-react-component="AccentCircles"]');
Array.from(accentCircleElements).forEach((el) => ReactDOM.render(<AccentCircles/>, el));